import React, { Component, Fragment } from "react";
import { Avatar, Col, Divider, List, Modal, Row, Table, Tooltip } from "antd";
import moment from "moment-jalaali";
import { PriceFormat } from "../scripts/helpers";
import { Constants } from "../scripts/settings";
import Resources from "../scripts/resources";

class OrderView extends Component {
  render() {
    const { data, onClose, visible } = this.props;

    console.log("oreder data is : ", data);

    const columns = [
      {
        title: Resources.title,
        dataIndex: "name",
      },
      {
        title: Resources.image,
        dataIndex: "gallery",
        width: "50px",
        render: (val) => {
          const image = val.length ? val[0].image : null;
          return (
            <Tooltip
              title={
                <Avatar
                  src={`${Constants.imagePathProduct}${image}`}
                  shape="square"
                  size={200}
                />
              }
            >
              <Avatar
                src={`${Constants.imagePathProduct}${image}`}
                shape="square"
                size="small"
              />
            </Tooltip>
          );
        },
      },
      {
              title: Resources.supplier,
              dataIndex: "supplier",
              className: "col-centvaler",
              width: "150px",
              render: (val) => (val) ? (val?.name + " "+ val?.family) : ""
            },
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        width: "150px",
      },
      {
        title: Resources.count,
        dataIndex: "pivot",
        key: "count",
        className: "col-center",
        width: "50px",
        render: (val) => val.count,
      },
      {
        title: `قیمت پایه`,
        dataIndex: "pivot",
        className: "col-center",
        width: "100px",
        render: (val) => PriceFormat(parseInt(val.price)),
      },
      {
        title: `${Resources.discount} (${Resources.rial})`,
        dataIndex: "pivot",
        key: "discount",
        className: "col-center",
        width: "100px",
        render: (val) => {
          return PriceFormat(parseInt(val.offer));
        },
      },
      {
        title: `قیمت نهایی`,
        dataIndex: "pivot",
        key: "sum",
        className: "col-center",
        width: "100px",
        render: (val) => PriceFormat(parseInt(val.payable)),
      },
    ];

    const types = {
      orderType: {
        voip: Resources.withPhone,
        android: Resources.android,
        ios: Resources.ios,
        web: Resources.web,
      },
      postType: {
        delivery: Resources.storeCourier,
      },
      payType: {
        cardReader: Resources.pos,
        cash: Resources.cash,
        credit: Resources.credential,
        port: Resources.port,
      },
      status: {
        0: Resources.suspend,
        1: Resources.process,
        2: Resources.submit,
        3: Resources.delivered,
        4: Resources.returned,
      },
    };

    return (
      <Modal
        title={Resources.view}
        visible={visible}
        onCancel={onClose}
        footer={false}
        width={1000}
      >
        <Table
          columns={columns}
          dataSource={data.product ? data.product : []}
          pagination={false}
          size="small"
          rowKey="id"
          scroll={{ x: 952 }}
        />
        <List
          size="small"
          style={{ backgroundColor: "#fafafa", paddingRight: 8 }}
        >
          <List.Item>
            <List.Item.Meta title={`${Resources.sum} ${Resources.factor}`} />
            <span style={{ width: 100, textAlign: "center" }}>
              {PriceFormat(data.total)}
            </span>
          </List.Item>
          <List.Item>
            <List.Item.Meta title={Resources.transferCost} />
            <span style={{ width: 100, textAlign: "center" }}>
              {PriceFormat(data.transferringCost)}
            </span>
          </List.Item>
          <List.Item>
            <List.Item.Meta title={Resources.discount} />
            <span style={{ width: 100, textAlign: "center" }}>
              {PriceFormat(data.total - data.payable)}
            </span>
          </List.Item>
          <List.Item>
            <List.Item.Meta title={Resources.finalPrice} />
            <span style={{ width: 100, textAlign: "center" }}>
              {PriceFormat(data.payable)}
            </span>
          </List.Item>
        </List>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Divider style={{ marginBottom: 0 }}>
              {Resources.information} {Resources.user}
            </Divider>
            <List size="small">
              <List.Item>
                <List.Item.Meta title={Resources.date} />
                <div
                  className="ant-list-item-meta-description"
                  style={{ direction: "ltr" }}
                >
                  {moment(data.created_at).format(Constants.jDateTimeFormat)}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta title={Resources.user} />
                <div className="ant-list-item-meta-description">
                  {data.user
                    ? data.user.name
                      ? `${data.user.name} ${data.user.family}`
                      : data.user.family
                    : ""}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta title={Resources.mobile} />
                <div className="ant-list-item-meta-description">
                  {data.user ? data.user.phone : ""}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.type} ${Resources.order}`}
                />
                <div className="ant-list-item-meta-description">
                  {types.orderType[data.orderType]}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.status} ${Resources.user}`}
                />
                <div className="ant-list-item-meta-description">
                  {data.user ? data.user.type || "-" : ""}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.status} ${Resources.payment}`}
                />
                <div className="ant-list-item-meta-description">
                  {data.payment && data.payment.status
                    ? Resources.successful
                    : Resources.unsuccessful}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.address} ${Resources.user}`}
                  description={data.address || "-"}
                />
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.description} ${Resources.user}`}
                  description={data.descriptionUser || "-"}
                />
              </List.Item>
            </List>
          </Col>
          <Col xs={24} md={12}>
            <Divider style={{ marginBottom: 0 }}>
              {Resources.information} {Resources.order}
            </Divider>
            <List size="small">
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.type} ${Resources.payment}`}
                />
                <div className="ant-list-item-meta-description">
                  {types.payType[data.paymentType]}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.type} ${Resources.submit}`}
                />
                <div className="ant-list-item-meta-description">
                  {types.postType[data.postType]}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.firstName} ${Resources.carrier}`}
                />
                <div className="ant-list-item-meta-description">
                  {data.delivery &&
                  data.delivery.postman &&
                  data.delivery.postman.user
                    ? data.delivery.postman.user.name
                      ? `${data.delivery.postman.user.name} ${data.delivery.postman.user.family}`
                      : data.delivery.postman.user.name
                    : ""}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta title={Resources.status} />
                <div className="ant-list-item-meta-description">
                  {types.status[data.status]}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  title={`${Resources.description} ${Resources.carrier}`}
                  description={data.descriptionPostman || "-"}
                />
              </List.Item>
            </List>
          </Col>
        </Row>
        {data.payment && (
          <Fragment>
            <Divider style={{ marginBottom: 0 }}>{Resources.bankInfo}</Divider>
            <List size="small">
              <List.Item>
                <List.Item.Meta title={Resources.dateAndTime} />
                <div
                  className="ant-list-item-meta-description"
                  style={{ direction: "ltr" }}
                >
                  {moment(data.payment.time).format(Constants.jDateTimeFormat)}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta title={Resources.trackingCode} />
                <div className="ant-list-item-meta-description">
                  {data.payment.resNumber}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta title={Resources.status} />
                <div className="ant-list-item-meta-description">
                  {data.payment.status
                    ? Resources.successful
                    : Resources.unsuccessful}
                </div>
              </List.Item>
              <List.Item>
                <List.Item.Meta title={Resources.amount} />
                <div className="ant-list-item-meta-description">
                  {PriceFormat(data.payment.price)}
                </div>
              </List.Item>
            </List>
          </Fragment>
        )}
      </Modal>
    );
  }
}

export default OrderView;
